// Поиск по названию в списках: без учёта регистра и «ё», все слова запроса должны встретиться в тексте

const fold = (s: string | null | undefined): string => String(s || '').toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();

/** Подходит ли запись под запрос; пустой запрос — подходит любая */
export function matchesQuery(q: string, ...parts: (string | null | undefined)[]): boolean {
  const words = fold(q).split(' ').filter(Boolean);
  if (!words.length) return true;
  const text = fold(parts.filter(Boolean).join(' '));
  return words.every((w) => text.includes(w));
}
